import axios from 'axios'

export const ZENDESK_SECTION_MAP = {
  'SIPP-TRANSFERS': '13921684213277-SIPP-transfers',
}

export type ZendeskSectionName = keyof typeof ZENDESK_SECTION_MAP

export type ZendeskArticleDTO = {
  id: number
  title: string
  html_url: string
}

export const fetchZendeskArticlesFromSection = async (
  sectionName: ZendeskSectionName,
): Promise<ZendeskArticleDTO[]> => {
  const { data } = await axios.get(
    `https://investengine.zendesk.com/api/v2/help_center/sections/${ZENDESK_SECTION_MAP[sectionName]}/articles`,
  )

  return data.articles
}
